/**
 * Название Cookie, для получения аб фич
 */
export const PAGE_FEATURES_COOKIE_NAME = 'jl_features';

